import type { PlusFeatureHighlight } from './PlusBlockerDialog.types';

export const plusFeatureHighlights: PlusFeatureHighlight[] = [
  {
    key: 'forstand-file',
    title: 'Din plan i vårt system',
    description: 'Du får tillgång till hela treebulas platform fast med din egen data',
    imageUrl: 'img/subscriptions/skogsbruksplan.webp'
  },
  {
    key: 'property-value',
    title: 'Värdera din skog',
    description: 'Vi värderar din skog baserat på den senast tillgängliga informationen',
    imageUrl: 'img/subscriptions/property-value.webp'
  },
  {
    key: 'property-data',
    title: 'Detaljerad data om din skog',
    description: 'Vi samlar och presenterar den mest relevanta informationen om din skog',
    imageUrl: 'img/subscriptions/property-data.webp'
  },
  {
    key: 'section-details',
    title: 'Detaljerad avdelningsdata',
    description: 'Vi samlar och presenterar den mest relevanta informationen om din skog',
    imageUrl: 'img/subscriptions/section-details.webp'
  },
  {
    key: 'map-layers',
    title: 'Kartlager & ortofoto',
    description: 'Alla relevanta kartlager samlade i en användarvänlig vy',
    imageUrl: 'img/subscriptions/map-layers.webp'
  },
  {
    key: 'map-editing',
    title: 'Rita, radera och ändra',
    description:
      'Med våra enkla redigeringsverktyg kan du själv rita nya avdelningar, justera gränser och ändra information direkt i skogsbruksplanen. Du har kontrollen, vi sköter tekniken.',
    imageUrl: 'img/subscriptions/map-editing.webp'
  },
  {
    key: 'carbon-credits',
    title: 'Utforska kolkrediter',
    description:
      'Vi analyserar din skog och presenterar potetialen för kolkrediter med våra partners',
    imageUrl: 'img/subscriptions/carbon-credits.webp'
  },
  {
    key: 'drone-analysis',
    title: 'Drönaranalys',
    description:
      'Köp drönaranalys (extra kostnad) av din skog och få resultatet direkt i din skogsbruksplan',
    imageUrl: 'img/subscriptions/drone.webp'
  },
  {
    key: 'dfr',
    title: 'Din skog under uppsikt',
    description:
      'Som Pluskund hos Treebula satellitövervakar vi din skog och meddelar dig om något händer',
    imageUrl: 'img/subscriptions/dfr.webp'
  },
  {
    key: 'price-comparison',
    title: 'Vår virkesprisjämförelse',
    description: 'Vår prisjämförelse bygger på unik statistik och ger dig bästa möjliga underlag',
    imageUrl: 'img/subscriptions/price-comparison.webp'
  },
  {
    key: 'forest-advisory',
    title: 'Skoglig expertis',
    description: 'Vi hjälper dig om det finns frågor kring ditt skogsbruk och dina affärer',
    imageUrl: 'img/subscriptions/forest-advisory.webp'
  }
];

export const plusFeatures = [
  {
    title: 'Sälja virke & biobränsle',
    description:
      'Tillgång till Treebulas marknadsplats för slutavverkning och gallring. Konkurrensutsätt ditt virke och få bästa möjliga pris',
    includedIn: ['bas', 'plus'],
    key: 'sales'
  },
  {
    title: 'Digital skogsbruksplan',
    description:
      'Få en tydlig överblick över hela din fastighet med uppdaterad fakta, kartor, ekonomisk potential och mycket mer, direkt i mobilen.',
    includedIn: ['bas', 'plus'],
    key: 'plan'
  },
  {
    title: 'Interaktiv skogskarta',
    description:
      'Med vår interaktiva skogskarta får du en tydligare överblick av din fastighet. Klicka dig fram mellan avdelningarna för att direkt se detaljerad information om ett specifikt område.',
    includedIn: ['bas', 'plus'],
    key: 'plan-map'
  },
  {
    title: 'Automatisk uppdatering',
    description: 'Vi uppdaterar din skogsbruksplan när ny information blir tillgänglig',
    includedIn: ['bas', 'plus'],
    key: 'plan-update'
  },
  {
    title: 'Marknadsinformation',
    description:
      'Håll dig uppdaterad med Treebulas unika och oberoendeanalys av marknaden, så att du kan känna dig trygg in dina beslut.',
    includedIn: ['bas', 'plus'],
    key: 'market'
  },
  {
    title: 'Virkesprisindikatorn',
    description:
      'Treebulas unika Virkesprisindikator ger en vägledning om vartåt virkespriserna sannolikt kan komma att röra sig framåt.',
    includedIn: ['bas', 'plus'],
    key: 'price-indicator'
  },
  {
    title: 'Kolkrediter est. värde',
    description: 'Vi analyserar och visar potentialen för kolkrediter i din skog.',
    includedIn: ['bas', 'plus'],
    key: 'carbon-value'
  },
  {
    title: 'Redigera skogsbruksplan (rita, ändra, justera)',
    description:
      'Med våra enkla redigeringsverktyg kan du själv rita nya avdelningar, justera gränser och ändra information direkt i skogsbruksplanen. Du har kontrollen, vi sköter tekniken.',
    includedIn: ['plus'],
    key: 'plan-edit'
  },
  {
    title: 'Anteckningar och beskrivningar per avdelning',
    description:
      'Markera händelser, planera åtgärder och anteckna direkt i kartan medan du står i skogen. Det sparar tid och gör nästa åtgärd betydligt enklare, oavsett om du ska ta dit en entreprenör eller planera själv.',
    includedIn: ['plus'],
    key: 'plan-notes'
  },
  {
    title: 'Kartlager & ortofoto',
    description: 'Alla relevanta kartlager samlade i en användarvänlig vy.',
    includedIn: ['plus'],
    key: 'map-layers'
  },
  {
    title: 'Skogsöverblick',
    description:
      'Vi sammanställer allt från fastighetsvärde till beståndsdata i en tydlig överblick. Med Treebula Plus får du de mest värdefulla insikterna och ser potentialen i din skog på ett helt nytt sätt.',
    includedIn: ['plus'],
    key: 'forest-overview'
  },
  {
    title: 'Ladda upp skogsbruksplan (Forestand)',
    description:
      'Har du redan en skogsbruksplan i ForeStand-format? Ladda upp den direkt i vårt system. Vi ser till att din befintliga avdelningsindelning och data följer med, så att du kan fortsätta ditt skogsbruk digitalt utan att behöva börja om från noll.',
    includedIn: ['plus'],
    key: 'forstand-upload'
  },
  {
    title: 'Ladda ner skogsbruksplan som PDF',
    description:
      'Förvandla din digitala plan till ett PDF-dokument. Perfekt att skriva ut eller dela med banken och samarbetspartners.',
    includedIn: ['plus'],
    key: 'plan-pdf'
  },
  {
    title: 'Volym, areal & bonitet',
    description:
      'Den senast tillgängliga informationen, så som aktuell volym, areal och bonitet per avdelning och för fastigheten',
    includedIn: ['plus'],
    key: 'volume-area'
  },
  {
    title: 'Trädslags- & åldersfördelning',
    description:
      'Få en sammanställning över trädslagsfördelning och ålder, både per avdelning och för hela fastigheten. Enkelt, tydligt och alltid uppdaterat.',
    includedIn: ['plus'],
    key: 'species-age'
  },
  {
    title: 'Huggningsklasser',
    description: 'Vi analyserar dina bestånd och föreslår huggningsklasser per avdelning.',
    includedIn: ['plus'],
    key: 'cutting-classes'
  },
  {
    title: 'Verkliga virkespriser',
    description:
      'Unik statistik som bygger på riktiga affärer gjorda på Treebulas marknadsplats för virke.',
    includedIn: ['plus'],
    key: 'prices-real'
  },
  {
    title: 'Timmer- & massavedspriser',
    description: 'Uppdaterad information om vad olika skogsbolag betalar för virke.',
    includedIn: ['plus'],
    key: 'prices-timber'
  },
  {
    title: 'Virkespriskollen',
    description: 'Redan fått anbud? Vi hjälper dig jämföra och göra en bra affär.',
    includedIn: ['plus'],
    key: 'price-check'
  },
  {
    title: 'Fastighetsvärdering',
    description:
      'En uppdaterad fastighetsvärdering baserad på senaste publika prisstatistiken och virkesförråd.',
    includedIn: ['plus'],
    key: 'valuation'
  },
  {
    title: 'Historisk prisutveckling',
    description: 'Historisk data som visar prisutvecklingen på skogsfastigheter i ditt område.',
    includedIn: ['plus'],
    key: 'price-history'
  },
  {
    title: 'Skogsskador & risker',
    description:
      'Få en riskbedömning för skogsskador i din skog. Vi kombinerar data för brand, barkborre, väder m.m. för att ge dig en överskådlig status.',
    includedIn: ['plus'],
    key: 'monitoring'
  },
  {
    title: 'Väder, vind & klimatdata',
    description:
      'Genom att analysera historiska och aktuella vinddata visar vi om det finns risk för skador.',
    includedIn: ['plus'],
    key: 'weather-data'
  },
  {
    title: 'Avverkningsanmälan i närheten',
    description: 'Ska grannen avverka? Vi visar om och var det görs anmälan i närheten.',
    includedIn: ['plus'],
    key: 'harvest-notice'
  },
  {
    title: 'Tjäna kolkrediter',
    description:
      'Se om din skog har potential för kolkrediter, det estimerade värdet och kom igång enkelt att tjänat kolkrediter.',
    includedIn: ['plus'],
    key: 'carbon'
  },
  {
    title: 'Personlig rådgivning',
    description:
      'Om du behöver stöd eller vägledning finns våra rådgivare alltid redo att hjälpa dig.',
    includedIn: ['plus'],
    key: 'advice'
  }
];
